// src/lib/env.ts

/**
 * Utility to get environment variables with runtime fallback (window._env_)
 * primarily for App Runner / Docker dynamic environment injection.
 */
export const getEnvVar = (key: string, defaultValue: string = ''): string => {
  if (typeof window === 'undefined') return defaultValue;
  // Prioritize runtime window._env_ (injected by entrypoint.sh)
  // Fallback to build-time import.meta.env (baked in by Vite)
  return (window as any)._env_?.[key] || (import.meta as any).env[key] || defaultValue;
};

export const ENV = {
  // API Endpoints
  VITE_BASE_URL: getEnvVar('VITE_BASE_URL'),
  VITE_AWS_API_GATEWAY_URL: getEnvVar('VITE_AWS_API_GATEWAY_URL'),
  FACE_BIOMETRIC_API_BASE_URL: getEnvVar('FACE_BIOMETRIC_API_BASE_URL'),

  // AWS Configuration
  VITE_AWS_REGION: getEnvVar('VITE_AWS_REGION', 'us-east-1'),
  VITE_AWS_USER_POOL_ID: getEnvVar('VITE_AWS_USER_POOL_ID'),
  VITE_AWS_APP_CLIENT_ID: getEnvVar('VITE_AWS_APP_CLIENT_ID'),
  VITE_AWS_S3_BUCKET: getEnvVar('VITE_AWS_S3_BUCKET'),
  VITE_AWS_S3_REGION: getEnvVar('VITE_AWS_S3_REGION', 'us-east-1'),
  VITE_AWS_IDENTITY_POOL_ID: getEnvVar('VITE_AWS_IDENTITY_POOL_ID'),

  // Amazon Connect CCP
  VITE_CONNECT_CCP_URL: getEnvVar('VITE_CONNECT_CCP_URL'),
  // SAML login URL — Cognito hosted UI with Connect redirect
  // Format: https://<cognito-domain>.auth.us-east-1.amazoncognito.com/login
  //         ?client_id=<app-client-id>&response_type=code
  //         &scope=email+openid+profile
  //         &redirect_uri=https://survey-dev.monitorhealth.ai/
  VITE_CONNECT_LOGIN_URL: getEnvVar('VITE_CONNECT_LOGIN_URL'),

  // Vite Build Mode
  isDev: (import.meta as any).env.DEV,
};

export default ENV;
